import { configureStore } from "@reduxjs/toolkit";
import alertSlice from "./slices/alert";
import authSlice from "./slices/auth";
import requestsSlice from "./slices/requests";
import roomsSlice from "./slices/rooms";
import devicesSlice from "./slices/devices";
import insightsSlice from "./slices/insights";
import communicationSlice from "./slices/communication";
import contentSlice from "./slices/content";
import uploadsSlice from "./slices/uploads";
import surveysSlice from "./slices/surveys";
import orientationSlice from "./slices/orientation";
import integrationSlice from "./slices/integration";
import smartControlSlice from "./slices/smart_control";
import propertySlice from "./slices/property";
import paymentSlice from "./slices/payment";
import confirmationSlice from "./slices/confirmation";
import tasksSlice from "./slices/tasks";
import oversightSlice from "./slices/oversight";
import thirdPartySlice from "./slices/third_party";
import portalSlice from "./slices/portal";

export const store = configureStore({
  reducer: {
    alert: alertSlice,
    auth: authSlice,
    requests: requestsSlice,
    rooms: roomsSlice,
    devices: devicesSlice,
    insights: insightsSlice,
    communication: communicationSlice,
    content: contentSlice,
    uploads: uploadsSlice,
    surveys: surveysSlice,
    orientation: orientationSlice,
    integration: integrationSlice,
    smartControl: smartControlSlice,
    property: propertySlice,
    payment: paymentSlice,
    confirmation: confirmationSlice,
    tasks: tasksSlice,
    oversight: oversightSlice,
    thirdParty: thirdPartySlice,
    portal: portalSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
